/* eslint-disable */
/* tslint:disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  UUID: { input: string; output: string; }
};

export type AuthResult = {
  __typename?: 'AuthResult';
  accessToken: Scalars['String']['output'];
};

export type Content = {
  __typename?: 'Content';
  author?: Maybe<ContentAuthor>;
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<File>;
  name: Scalars['String']['output'];
  perex: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo: ContentSeo;
  tags: Array<ContentTag>;
  type: ContentType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentAuthor = {
  __typename?: 'ContentAuthor';
  avatar?: Maybe<File>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type ContentSeo = {
  __typename?: 'ContentSeo';
  description: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ogDescription: Scalars['String']['output'];
  ogImage?: Maybe<File>;
  ogTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentTag = {
  __typename?: 'ContentTag';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum ContentType {
  Blog = 'BLOG',
  LandingPage = 'LANDING_PAGE',
  Question = 'QUESTION',
  Term = 'TERM'
}

export type File = {
  __typename?: 'File';
  extension: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  namespace?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type LeadInput = {
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  package?: InputMaybe<LeadPackage>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: LeadType;
};

export enum LeadPackage {
  Medium = 'MEDIUM',
  Platinum = 'PLATINUM',
  Start = 'START'
}

export enum LeadType {
  General = 'GENERAL',
  UxAudit = 'UX_AUDIT'
}

export type Mutation = {
  __typename?: 'Mutation';
  authLogin: AuthResult;
  leadCreate: Scalars['Boolean']['output'];
};


export type MutationAuthLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLeadCreateArgs = {
  lead: LeadInput;
};

export type Query = {
  __typename?: 'Query';
  content: Content;
  contents: Array<Content>;
  health: Scalars['Boolean']['output'];
  question: Question;
  questions: Array<Question>;
};


export type QueryContentArgs = {
  content: Scalars['Int']['input'];
};


export type QueryContentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tagCodes?: Array<Scalars['String']['input']>;
  type?: InputMaybe<ContentType>;
};


export type QueryQuestionArgs = {
  question: Scalars['Int']['input'];
};


export type QueryQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tagCodes?: Array<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  answer: Scalars['String']['output'];
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  seo: ContentSeo;
  tags: Array<ContentTag>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FileFragment = { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null };

export type ContentAuthorFragment = { __typename?: 'ContentAuthor', id: number, firstName: string, lastName: string, avatar?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null };

export type ContentTagFragment = { __typename?: 'ContentTag', id: number, code: string, label: string };

export type ContentSeoFragment = { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null };

export type ContentFragment = { __typename?: 'Content', id: number, type: ContentType, name: string, perex: string, hidden: boolean, publishedAt?: string | null, createdAt: string, updatedAt: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, image?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null, author?: { __typename?: 'ContentAuthor', id: number, firstName: string, lastName: string, avatar?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null } | null, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> };

export type QuestionFragment = { __typename?: 'Question', id: number, question: string, answer: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> };

export type ContentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tagCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContentsQuery = { __typename?: 'Query', contents: Array<{ __typename?: 'Content', id: number, type: ContentType, name: string, perex: string, hidden: boolean, publishedAt?: string | null, createdAt: string, updatedAt: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, image?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null, author?: { __typename?: 'ContentAuthor', id: number, firstName: string, lastName: string, avatar?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null } | null, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> }> };

export type ContentQueryVariables = Exact<{
  contentId: Scalars['Int']['input'];
}>;


export type ContentQuery = { __typename?: 'Query', content: { __typename?: 'Content', id: number, type: ContentType, name: string, perex: string, hidden: boolean, publishedAt?: string | null, createdAt: string, updatedAt: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, image?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null, author?: { __typename?: 'ContentAuthor', id: number, firstName: string, lastName: string, avatar?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null } | null, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> } };

export type QuestionQueryVariables = Exact<{
  questionId: Scalars['Int']['input'];
}>;


export type QuestionQuery = { __typename?: 'Query', question: { __typename?: 'Question', id: number, question: string, answer: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> } };

export type QuestionsQueryVariables = Exact<{
  tagCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type QuestionsQuery = { __typename?: 'Query', questions: Array<{ __typename?: 'Question', id: number, question: string, answer: string, content: any, seo: { __typename?: 'ContentSeo', name?: string | null, title: string, description: string, ogTitle: string, ogDescription: string, ogImage?: { __typename?: 'File', id: number, uuid: string, type: string, extension: string, namespace?: string | null } | null }, tags: Array<{ __typename?: 'ContentTag', id: number, code: string, label: string }> }> };

export type LeadCreateMutationVariables = Exact<{
  lead: LeadInput;
}>;


export type LeadCreateMutation = { __typename?: 'Mutation', leadCreate: boolean };

export const FileFragmentDoc = gql`
    fragment File on File {
  id
  uuid
  type
  extension
  namespace
}
    `;
export const ContentSeoFragmentDoc = gql`
    fragment ContentSeo on ContentSeo {
  name
  title
  description
  ogTitle
  ogDescription
  ogImage {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const ContentAuthorFragmentDoc = gql`
    fragment ContentAuthor on ContentAuthor {
  id
  firstName
  lastName
  avatar {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const ContentTagFragmentDoc = gql`
    fragment ContentTag on ContentTag {
  id
  code
  label
}
    `;
export const ContentFragmentDoc = gql`
    fragment Content on Content {
  id
  type
  name
  perex
  seo {
    ...ContentSeo
  }
  hidden
  image {
    ...File
  }
  publishedAt
  author {
    ...ContentAuthor
  }
  createdAt
  updatedAt
  content
  tags {
    ...ContentTag
  }
}
    ${ContentSeoFragmentDoc}
${FileFragmentDoc}
${ContentAuthorFragmentDoc}
${ContentTagFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  question
  answer
  seo {
    ...ContentSeo
  }
  content
  tags {
    ...ContentTag
  }
}
    ${ContentSeoFragmentDoc}
${ContentTagFragmentDoc}`;
export const ContentsDocument = gql`
    query Contents($limit: Int, $offset: Int, $tagCodes: [String!]!) {
  contents(limit: $limit, offset: $offset, tagCodes: $tagCodes) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;

/**
 * __useContentsQuery__
 *
 * To run a query within a React component, call `useContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tagCodes: // value for 'tagCodes'
 *   },
 * });
 */
export function useContentsQuery(baseOptions: Apollo.QueryHookOptions<ContentsQuery, ContentsQueryVariables> & ({ variables: ContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentsQuery, ContentsQueryVariables>(ContentsDocument, options);
      }
export function useContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentsQuery, ContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentsQuery, ContentsQueryVariables>(ContentsDocument, options);
        }
export function useContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentsQuery, ContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentsQuery, ContentsQueryVariables>(ContentsDocument, options);
        }
export type ContentsQueryHookResult = ReturnType<typeof useContentsQuery>;
export type ContentsLazyQueryHookResult = ReturnType<typeof useContentsLazyQuery>;
export type ContentsSuspenseQueryHookResult = ReturnType<typeof useContentsSuspenseQuery>;
export type ContentsQueryResult = Apollo.QueryResult<ContentsQuery, ContentsQueryVariables>;
export const ContentDocument = gql`
    query Content($contentId: Int!) {
  content(content: $contentId) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useContentQuery(baseOptions: Apollo.QueryHookOptions<ContentQuery, ContentQueryVariables> & ({ variables: ContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export function useContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentSuspenseQueryHookResult = ReturnType<typeof useContentSuspenseQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const QuestionDocument = gql`
    query Question($questionId: Int!) {
  question(question: $questionId) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useQuestionQuery__
 *
 * To run a query within a React component, call `useQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useQuestionQuery(baseOptions: Apollo.QueryHookOptions<QuestionQuery, QuestionQueryVariables> & ({ variables: QuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
      }
export function useQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export function useQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export type QuestionQueryHookResult = ReturnType<typeof useQuestionQuery>;
export type QuestionLazyQueryHookResult = ReturnType<typeof useQuestionLazyQuery>;
export type QuestionSuspenseQueryHookResult = ReturnType<typeof useQuestionSuspenseQuery>;
export type QuestionQueryResult = Apollo.QueryResult<QuestionQuery, QuestionQueryVariables>;
export const QuestionsDocument = gql`
    query Questions($tagCodes: [String!]!) {
  questions(limit: 999, offset: 0, tagCodes: $tagCodes) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useQuestionsQuery__
 *
 * To run a query within a React component, call `useQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsQuery({
 *   variables: {
 *      tagCodes: // value for 'tagCodes'
 *   },
 * });
 */
export function useQuestionsQuery(baseOptions: Apollo.QueryHookOptions<QuestionsQuery, QuestionsQueryVariables> & ({ variables: QuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
      }
export function useQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export function useQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export type QuestionsQueryHookResult = ReturnType<typeof useQuestionsQuery>;
export type QuestionsLazyQueryHookResult = ReturnType<typeof useQuestionsLazyQuery>;
export type QuestionsSuspenseQueryHookResult = ReturnType<typeof useQuestionsSuspenseQuery>;
export type QuestionsQueryResult = Apollo.QueryResult<QuestionsQuery, QuestionsQueryVariables>;
export const LeadCreateDocument = gql`
    mutation leadCreate($lead: LeadInput!) {
  leadCreate(lead: $lead)
}
    `;
export type LeadCreateMutationFn = Apollo.MutationFunction<LeadCreateMutation, LeadCreateMutationVariables>;

/**
 * __useLeadCreateMutation__
 *
 * To run a mutation, you first call `useLeadCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadCreateMutation, { data, loading, error }] = useLeadCreateMutation({
 *   variables: {
 *      lead: // value for 'lead'
 *   },
 * });
 */
export function useLeadCreateMutation(baseOptions?: Apollo.MutationHookOptions<LeadCreateMutation, LeadCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadCreateMutation, LeadCreateMutationVariables>(LeadCreateDocument, options);
      }
export type LeadCreateMutationHookResult = ReturnType<typeof useLeadCreateMutation>;
export type LeadCreateMutationResult = Apollo.MutationResult<LeadCreateMutation>;
export type LeadCreateMutationOptions = Apollo.BaseMutationOptions<LeadCreateMutation, LeadCreateMutationVariables>;